import {
  convertToEasternTime,
  normalizeIsoStringToUtc,
} from "./formatDateTime";

export const getDaysAgo = (date) => {
  if (!date) return "";

  // Convert the input date to Eastern Time
  const normalizedIso = normalizeIsoStringToUtc(date);
  const easternDate = convertToEasternTime(normalizedIso);
  if (!easternDate) return "";

  // Get current time in Eastern Time
  const nowUtc = new Date();
  const nowEastern = convertToEasternTime(nowUtc.toISOString());
  if (!nowEastern) return "";

  // Calculate days difference using Eastern Time dates
  // Reset both dates to midnight for accurate day comparison
  const dateAtMidnight = new Date(
    easternDate.getFullYear(),
    easternDate.getMonth(),
    easternDate.getDate()
  );
  const nowAtMidnight = new Date(
    nowEastern.getFullYear(),
    nowEastern.getMonth(),
    nowEastern.getDate()
  );

  const days = Math.floor(
    (nowAtMidnight - dateAtMidnight) / (1000 * 60 * 60 * 24)
  );

  return days;
  //   return days === 0 ? "today" : `${days} days ago`;
};
